import React, { useContext, useState } from "react";
import { Redirect } from "react-router-dom";
import { ConfigurationContext } from '../context/ConfigurationContext'
import { UserContext } from '../context/UserContext'
import QuestionButton from '../components/QuestionButton/QuestionButton'
import QuestionCheckbox from '../components/QuestionCheckbox/QuestionCheckbox'
import QuestionRadio from '../components/QuestionRadio/QuestionRadio'
import QuestionSlider from '../components/QuestionSlider/QuestionSlider'
import QuestionImage from '../components/QuestionImage/QuestionImage'
import QuestionCheckboxMulti from '../components/QuestionCheckboxMulti/QuestionCheckboxMulti'
import QuestionRadioMulti from '../components/QuestionRadioMulti/QuestionRadioMulti'
import Wysiwyg from '../components/Wysiwyg/Wysiwyg'
import polygraph from '../images/polygraph_bg.png'
import { CircularProgressbar } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

const ConfigView = () => {
  const [reset, setReset] = useState(false);
  const [state, setState] = useState({ pageIndex: null, redirect: false, toggleNext: false, togglePrev: false, nextDisabled: true });
  const { configurations } = useContext(ConfigurationContext);
  const { 
    setType,
    getAnswers,
    setAnswer,
    setAnswers,
    configurationId,
    setConfigurationId 
  } = useContext(UserContext);
  const [image, setImage] = useState({loaded: false});
  
  state.pageIndex = state.pageIndex === null ? 0 : state.pageIndex;
  
  if(reset === true) {
    setType(null)
    setConfigurationId(null);
    setAnswers([]);
    
    return <Redirect to='/start'/>;
  }
  
  const handleReset = () => {
    setReset(true);
  }
  
  if(!configurations || !configurationId) return <Redirect to='/'/>;
  
  const currentProduct = configurations.items.find( item => item.id === parseInt(configurationId));
  const currentOption = currentProduct.fields.find( (item) => {
    return state.pageIndex === item.id
  });

  const lastPosition = currentProduct.fields.length-1;
  const percentage = parseInt((state.pageIndex / ( lastPosition + 1)) * 100);
  const currentAnswer = getAnswers().find(i => i.id === state.pageIndex);
  const imageLoaded = image.loaded;

  if(state.redirect === true) return <Redirect to='/summary'/>;
  
  const handleAnswerCallback = (answer) => {
    const nextDisabled = answer === undefined;
    setAnswer(currentOption.id, answer);
    setState({...state, nextDisabled});
  }

  const handleSubmit = () => {
    setState( { ...state, redirect: true } );
  }

  if( state.toggleNext === true ) {
    const optionHasAnswer = getAnswers().find( i => i.id === currentOption.id );
    state.toggleNext = false;

    if(optionHasAnswer) {
      setState({ ...state, pageIndex: state.pageIndex+1 });
    }
  }

  if( state.togglePrev === true ) {
    state.togglePrev = false;

    setState({ pageIndex: state.pageIndex-1 });
  }

  const setNavigation = (e) => {
    const direction = e.target.closest("button").dataset.direction;

    if(direction === 'next') {
      setState({ ...state, toggleNext: true });
    } else if(direction === 'prev') {
      setState({ ...state, togglePrev: true });
    }
  }

  const optionType = currentOption.type;
  if(optionType !== 'radio' ) state.nextDisabled = false;
  let wrapClass = '';

  if(optionType === 'slider') {
    wrapClass = 'bg-white px-3 py-3 sm:px-3 sm:py-3 md:px-6 md:py-6 lg:px-10 lg:py-8';
  }

  const banner = document.querySelector('#banner');
  let bannerClasses = 'absolute w-full h-full';
  let bannerStyle = {};
  
  if(imageLoaded) {
    if(currentOption.drop_shadow && banner) {
      bannerClasses = 'shadow-lg shadow-['+currentOption.drop_shadow+'] blur absolute w-full h-full';
      
      banner.style['--tw-shadow-color'] = currentOption.drop_shadow;
      banner.style['--tw-shadow: var(--tw-shadow-colored)'] = 'var(--tw-shadow-colored)';
      banner.style['--tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color)'] = currentOption.drop_shadow;
    }
    bannerStyle = {
      shadow: {
        ['--tw-shadow-color']: currentOption.drop_shadow,
        ['--tw-shadow']: 'var(--tw-shadow-colored)',
        ['--tw-shadow-colored']: '0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color)'
      }
    }
  }

  return (
    <>
    <div className={"flex flex-row"}>
      <div className={"grid grid-cols-12 min-h-screen"}>
        <div className={"col-span-12 sm:col-span-12 md:col-span-5 lg:col-span-3 pl-10 pr-10 pt-5 sm:pt-20 bg-white relative overflow-hidden hidden sm:block"}>
          <div className={"grid min-h-full"}>
            <div className={"col-span-12"}>
              <a href={'/'}>
                <svg width="159.836" height="23.5" viewBox="0 0 159.836 23.5">
                  <defs>
                    <clipPath id="clipPath">
                      <rect id="Rectangle_1540" data-name="Rectangle 1540" width="159.836" height="23.5" fill="none"/>
                    </clipPath>
                  </defs>
                  <g id="Group_3205" data-name="Group 3205" clipPath="url(#clipPath)">
                    <path id="Path_3798" data-name="Path 3798" d="M0,23.765V1.308H4.276V9.591A6.168,6.168,0,0,1,9.293,7.1c4.141,0,7.2,3.232,7.2,8.518,0,5.454-3.1,8.552-7.2,8.552a6.313,6.313,0,0,1-5.017-2.491v2.087Zm7.98-3.4c2.457,0,4.107-1.919,4.107-4.747,0-2.795-1.65-4.714-4.107-4.714a4.783,4.783,0,0,0-3.7,1.886v5.757a4.826,4.826,0,0,0,3.7,1.818" transform="translate(0 -0.669)" fill="#252424"/>
                    <path id="Path_3799" data-name="Path 3799" d="M38.292,29.818V13.557h4.276v2.188a7.131,7.131,0,0,1,5.185-2.592v4.175a5.52,5.52,0,0,0-5.185,1.751v10.74Z" transform="translate(-19.571 -6.723)" fill="#252424"/>
                    <path id="Path_3800" data-name="Path 3800" d="M69.727,29.818V28.1a6.635,6.635,0,0,1-5.151,2.12,5.39,5.39,0,0,1-5.622-5.386c0-3.838,3.03-5.252,5.622-5.252a6.639,6.639,0,0,1,5.151,1.986V19.516c0-1.65-1.414-2.727-3.569-2.727a6.834,6.834,0,0,0-4.679,1.919l-1.683-3a10.5,10.5,0,0,1,7.1-2.559c3.737,0,7.137,1.481,7.137,6.161v10.5Zm0-3.905v-2.02a4.3,4.3,0,0,0-3.434-1.448c-1.683,0-3.064.909-3.064,2.458s1.38,2.424,3.064,2.424a4.275,4.275,0,0,0,3.434-1.414" transform="translate(-30.13 -6.723)" fill="#252424"/>
                    <path id="Path_3801" data-name="Path 3801" d="M94.145,2.525a2.542,2.542,0,0,1,5.084,0,2.542,2.542,0,1,1-5.084,0m.4,4.309h4.276V23.1H94.549Z" transform="translate(-48.117 0)" fill="#252424"/>
                    <path id="Path_3802" data-name="Path 3802" d="M121.305,29.818V19.987c0-2.256-1.178-3.03-3-3.03a4.755,4.755,0,0,0-3.7,1.886V29.818h-4.276V13.557h4.276v2.088a7.605,7.605,0,0,1,5.69-2.491c3.6,0,5.319,2.02,5.319,5.185V29.818Z" transform="translate(-56.388 -6.723)" fill="#252424"/>
                    <path id="Path_3803" data-name="Path 3803" d="M147.32,23.413V10.889h-2.693V7.151h2.693V6.478c0-3.67,2.189-5.858,5.454-5.858a5.661,5.661,0,0,1,4.242,1.549L155.4,4.761a2.5,2.5,0,0,0-1.784-.639c-1.213,0-2.02.774-2.02,2.357v.673h3.3v3.737h-3.3V23.413Z" transform="translate(-73.917 -0.317)" fill="#252424"/>
                    <path id="Path_3804" data-name="Path 3804" d="M166.459,21.671a8.6,8.6,0,0,1,17.2,0,8.6,8.6,0,0,1-17.2,0m12.76,0c0-2.525-1.481-4.714-4.175-4.714-2.66,0-4.141,2.189-4.141,4.714,0,2.558,1.481,4.747,4.141,4.747,2.693,0,4.175-2.189,4.175-4.747" transform="translate(-85.075 -6.723)" fill="#252424"/>
                    <path id="Path_3805" data-name="Path 3805" d="M206.127,29.818V13.557H210.4v2.188a7.131,7.131,0,0,1,5.185-2.592v4.175a5.52,5.52,0,0,0-5.185,1.751v10.74Z" transform="translate(-105.349 -6.723)" fill="#252424"/>
                    <path id="Path_3806" data-name="Path 3806" d="M226.718,21.671a8.3,8.3,0,0,1,8.417-8.518c4.882,0,8.148,3.636,8.148,8.922v1.01H231.2c.3,1.986,1.919,3.637,4.68,3.637a6.8,6.8,0,0,0,4.309-1.583l1.919,2.828a10.139,10.139,0,0,1-6.7,2.255c-4.949,0-8.687-3.333-8.687-8.552m8.417-5.017a3.75,3.75,0,0,0-3.972,3.468h8.013a3.727,3.727,0,0,0-4.04-3.468" transform="translate(-115.873 -6.723)" fill="#252424"/>
                    <path id="Path_3807" data-name="Path 3807" d="M261.98,27.7l1.852-3.1a9.215,9.215,0,0,0,5.622,2.256c1.852,0,2.727-.707,2.727-1.717,0-2.66-9.629-.471-9.629-6.868,0-2.727,2.357-5.117,6.666-5.117a10.36,10.36,0,0,1,6.531,2.222l-1.718,3.03a7.011,7.011,0,0,0-4.814-1.885c-1.549,0-2.559.674-2.559,1.583,0,2.39,9.662.37,9.662,6.936,0,3-2.558,5.184-7.07,5.184A10.948,10.948,0,0,1,261.98,27.7" transform="translate(-133.895 -6.723)" fill="#252424"/>
                    <path id="Path_3808" data-name="Path 3808" d="M294.632,21.521V13.07h-2.693V9.333h2.693V4.889h4.276V9.333h3.3V13.07h-3.3v7.306c0,1.044.539,1.818,1.481,1.818a2.153,2.153,0,0,0,1.482-.505l.909,3.265A5.279,5.279,0,0,1,299.211,26c-3,0-4.579-1.549-4.579-4.477" transform="translate(-149.207 -2.499)" fill="#252424"/>
                    <path id="Path_3809" data-name="Path 3809" d="M315.767,39.569a2.727,2.727,0,1,1,2.727,2.727,2.759,2.759,0,0,1-2.727-2.727" transform="translate(-161.385 -18.83)" fill="#252424"/>
                  </g>
                </svg>
              </a>

              <p className={"text-size-16 leading-line-height-16 mt-12"}>
                Varumärkestest
              </p>

              <h2 className={"text-size-40 leading-line-height-40 font-[800] text-purple mb-12"}>The<br/> brand<br/> polygraph</h2>

              <p className={"font-size-18 leading-line-height-18"}>Den nya generationen verksamheter vinner idag marknadsandelar genom att drivas av ett syfte och erbjuda relevanta värden för sin kunder.</p>

              <p className={"font-size-18 leading-line-height-18"}>De vill inte enbart vara lite bättre. De ser andra möjligheter. De tänker andra tankar. De definierar och formar sina marknader i linje med sina missioner och visioner. De gör kunderbjudandet tillgängligt genom digitala kanaler och lär känna sina kunder på en individuell nivå.</p>
          
              <div className={"flex justify-center mt-10 mb-10 z-20 relative"}>
                <div className={'w-44'}>
                  <CircularProgressbar
                  value={percentage}
                  text={`${percentage}%`}
                  styles={{
                    // Customize the root svg element
                    root: {},
                    // Customize the path, i.e. the "completed progress"
                    path: {
                      // Path color
                      stroke: `rgba(91, 88, 236, ${percentage / 100})`,
                      // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                      strokeLinecap: 'butt',
                      // Customize transition animation
                      transition: 'stroke-dashoffset 0.5s ease 0s',
                      // Rotate the path
                      transform: 'rotate(1turn)',
                      transformOrigin: 'center center',
                    },
                    // Customize the circle behind the path, i.e. the "total progress"
                    trail: {
                      // Trail color
                      stroke: '#DFDEFE',
                      // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
                      strokeLinecap: 'butt',
                      // Rotate the trail
                      transform: 'rotate(1turn)',
                      transformOrigin: 'center center',
                    },
                    // Customize the text
                    text: {
                      // Text color
                      fill: '#2C2C2C',
                      // Text size
                      fontSize: '16px',
                    },
                    // Customize background - only used when the `background` prop is true
                    background: {
                      fill: '#3e98c7',
                    }}}
                  />
                </div>
              </div>
            <div style={{  
              backgroundImage: "url(" + polygraph + ")",
              backgroundPosition: 'center',
              backgroundSize: 'cover',
              backgroundRepeat: 'no-repeat'
              
            }}
            className={'absolute right-0 left-0 bottom-0 pt-60'}
            >
            </div>
          </div>

            <div className={'self-end col-span-12 mb-10'}>
              <div className={"flex mtop-10 bg-white z-15 relative"}>
                <div className={"relative py-4 px-8 z-10 bottom-10 pt-14 h-80 w-full bg-white"}>
                  <div className={"flex flex-col h-full justify-end"}>
                    <p className={"text-size-13 leading-line-height-13 font-[500] uppercase font-medium"}>
                      Armbågavägen 10 | 506 30 BORÅS
                    </p>

                    <section className={"mb-4"}>
                      <a className={"text-size-13 leading-line-height-12 uppercase text-purple"} href="mail:INFO(AT)BRAINFOREST.SE">INFO(AT)BRAINFOREST.SE</a><br></br>
                      <a className={"text-size-13 leading-line-height-12 uppercase text-purple"} href="tel:0046337227750">+46 (0)33 722 77 50</a>
                    </section>

                    <section>
                      <a className={"text-size-13 leading-line-height-13 uppercase text-purple"} href={"https://www.brainforese.se"}>FACEBOOK</a>  <span className={"text-purple text-size-13 leading-line-height-13"}>/</span> <a className={"text-size-13 leading-line-height-13 uppercase text-purple"} href={"https://www.instagram.com/brainforestagency/"}>INSTAGRAM</a>  <span className={"text-purple text-size-13 leading-line-height-13"}>/</span>  <a className={"text-size-13 leading-line-height-13 uppercase text-purple"} href={"https://se.linkedin.com/company/brainforest-agency/"}>LINKEDIN</a>  <span className={"text-purple text-size-13 leading-line-height-13"}>/</span>  <a className={"text-size-13 leading-line-height-13 uppercase text-purple"} href={"https://vimeo.com/271690771"}>VIMEO</a>
                    </section>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={"col-span-12 sm:col-span-12 md:col-span-7 lg:col-span-9 pt-20 bg-white-2 relative px-4 sm:px-24 md:px-10 lg:px-40 pb-20 md:pb-30 lg:pb-40"}>
          <div className={"mx-auto max-w-2xl"}>
          <span className={"absolute sm:top-2 top-2 md:left-8 lg:left-2 lg:left-10"}>
            <div className={'text-center mt-4'}>
              <button className={'flex items-center text-medium no-underline text-black inline-block px-1 py-1'} onClick={handleReset}>
              <svg width="19" height="19" viewBox="0 0 19 19">
                <rect id="Rectangle_1535" data-name="Rectangle 1535" width="19" height="19" fill="none"/>
                <path id="Path_2440" data-name="Path 2440" d="M7.413,5,8.5,6.09,4.962,9.64h12.5v1.547H4.962l3.549,3.549-1.1,1.09L2,10.413Z" transform="translate(-0.012 -1.134)" fill="#5b58ec"/>
              </svg>
              <span className={"inline-block font-medium md:text-size-14 md:line-height-14 lg:text-size-16 lg-line-height-16 ml-0 ml-2 mt-0 lg:mt-1"}>Till start</span>
              </button>
            </div>
          </span>

          <div className={'relative mb-6'}>
            <div id={'banner'}  style={bannerStyle.shadow} className={bannerClasses}></div>
            <img src={currentOption.banner} onLoad={() => setImage({...image, loaded: true}) } className={'rounded-xl'} alt={currentOption.alt} />
          </div>

          <span className={'flex mb-4 mb-4 justify-start items-start'}>
            <span className={'text-size-12 leading-line-height-12 font-[500] text-purple'}>{ ' ' + (state.pageIndex+1) } </span>
            <span className={'text-pinkish text-size-14 mx-2'}>|</span>
            <span className={'text-size-12 leading-line-height-12 font-[500] text-gray'}>{ ' ' + (lastPosition+1) + ' ' }</span>
            <span className={"ml-4 text-size-14 font-[300] leading-line-height-16 text-purple"}>{ currentOption.categoryTitle }</span>
          </span>


          <div className={wrapClass}>
            <h1 className={"text-3xl text-size-24 line-height-24 font-[700] mb-1"}>{currentOption.heading}</h1>

            <p className={"text-base sm:text-xl mb-10 text-gray leading-line-height-12"}>{currentOption.text}</p>

            {currentOption.type === 'slider' ? 
              <>
                <QuestionSlider options={currentOption} callback={handleAnswerCallback} currentAnswer={currentAnswer} />
              </>
            : currentOption.type === 'checkbox' ?
                <QuestionCheckbox options={currentOption} callback={handleAnswerCallback} />
            : currentOption.type === 'button' ? 
              <QuestionButton options={currentOption.options} callback={handleAnswerCallback} currentAnswer={currentAnswer} />
            : currentOption.type === 'radio' ? 
              <>
              <QuestionRadio options={currentOption.options} callback={handleAnswerCallback} currentAnswer={currentAnswer} />
              </>
            : currentOption.type === 'image' ? 
              <QuestionImage options={currentOption.options} callback={handleAnswerCallback} currentAnswer={currentAnswer} />
            : currentOption.type === 'checkboxMulti' ?
              <QuestionCheckboxMulti options={currentOption} callback={handleAnswerCallback}  />
            : currentOption.type === 'radioMulti' ?
              <QuestionRadioMulti options={currentOption} callback={handleAnswerCallback} />
            : getAnswers().length === currentProduct.fields.length - 1 ?
              <Wysiwyg callback={handleAnswerCallback} currentAnswer={currentAnswer} />
            : currentOption.type === 'textblock' ?
              <Wysiwyg callback={handleAnswerCallback} currentAnswer={currentAnswer} />
            : null }

          </div>
          <div className={'text-center mt-16 sm:mt-10 flex justify-between'}>
            {state.pageIndex !== 0 ?
              <button id="prev" className={'btn no-underline font-700 text-black text-size-14  inline-block rounded-lg py-3.5 pl-4 pr-8 bg-white flex'} data-direction={ 'prev' } onClick={ setNavigation }>
                <svg width="19" height="19" viewBox="0 0 19 19">
                  <rect id="Rectangle_1535" data-name="Rectangle 1535" width="19" height="19" fill="none"/>
                  <path id="Path_2440" data-name="Path 2440" d="M7.413,5,8.5,6.09,4.962,9.64h12.5v1.547H4.962l3.549,3.549-1.1,1.09L2,10.413Z" transform="translate(-0.012 -1.134)" fill="#000"/>
                </svg>
                <span className={'pl-6'}>{'Föregående'}</span>
                </button>
            : null}

            <span className={'mx-3'}></span>
            
            {state.pageIndex !== lastPosition ?
              <button id="next" className={'btn no-underline font-700 text-white text-size-14  inline-block rounded-lg py-3.5 pl-8 pr-4 bg-purple disabled:bg-grayish-2 flex'} disabled={state.nextDisabled} data-direction={ 'next' } onClick={ setNavigation }>
                <span className={'pr-6'}>{'Nästa'}</span>
                <svg className={'rotate-180'} width="19" height="19" viewBox="0 0 19 19">
                  <rect id="Rectangle_1535" data-name="Rectangle 1535" width="19" height="19" fill="none"/>
                  <path id="Path_2440" data-name="Path 2440" d="M7.413,5,8.5,6.09,4.962,9.64h12.5v1.547H4.962l3.549,3.549-1.1,1.09L2,10.413Z" transform="translate(-0.012 -1.134)" fill="#fff"/>
                </svg>
            </button>
            : 
                <button
                  type="button"
                  value="Nästa"
                  className="btn no-underline font-700 text-white text-size-14  inline-block rounded-lg py-3.5 px-8 bg-purple"
                  onClick={handleSubmit}
                >
                  {'Nästa'}
                 
                </button>
              }
          </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default ConfigView;
